<template>
    <v-app>
        <app-top-bar :menu="menu" :color="'linear-gradient(135deg, #283593 0%, #3F51B5 100%)'" :moduleName="'WEBSITE MODULE'"/>
        <v-main>
        <router-view/>
        </v-main>
  </v-app>
</template>

<script>
import AppTopBar from '../components/AppTopAndSideBar.vue';

export default {
  components: { AppTopBar},
    name: 'SchoolWebsiteLayout',
    data: () => ({
        menu: [
            {
                text: 'All Modules',
                icon: 'mdi-view-dashboard', // ✅ General dashboard
                routerName: 'ModuleSelector'
            },
            {
                text: 'Website Dashboard',
                icon: 'mdi-web', // 🌐 Better for website-specific dashboard
                routerName: 'SchoolWebsiteDashboard'
            },
            // {
            //     text: 'Website Settings',
            //     icon: 'mdi-cog-outline', // ⚙️ Clearer for settings
            //     routerName: 'SchoolWebsiteSettings'
            // },
            // {
            //     text: 'Page Editor',
            //     icon: 'mdi-file-document-edit-outline', // 📝 Better for editing pages
            //     routerName: 'SchoolWebsitePageEditor'
            // },
            // {
            //     text: 'Media Manager',
            //     icon: 'mdi-folder-multiple-image', // 🖼️ Fits media/images manager
            //     routerName: 'SchoolWebsiteMediaManager'
            // }
        ]

    }),
};
</script>